import { render, staticRenderFns } from "./TypeSol.vue?vue&type=template&id=5e21946e&scoped=true&class=container&"
import script from "./TypeSol.vue?vue&type=script&lang=js&"
export * from "./TypeSol.vue?vue&type=script&lang=js&"
import style0 from "./TypeSol.vue?vue&type=style&index=0&id=5e21946e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e21946e",
  null
  
)

export default component.exports